import type { InjectionKey } from 'vue'

import type { IAnalyticsService } from './analytics.types'

export const AnalyticsKey: InjectionKey<IAnalyticsService> = Symbol('Analytics')
